module.exports = __webpack_public_path__ + "img/BAU Seniors_11.f8c50a9a.jpg";